module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24463/sass/messagesWidgetShell.sass"